import React from 'react'
import { useTranslation } from 'react-i18next'
import { Radio, Select } from 'components/forms'
import { RadioGroup } from 'informed'
import Divider from 'components/Divider'
import listTags from 'gql/query/listTags'
import { listCashRegisters } from 'gql/query'

const FilterComponent = ({ clearFilter }) => {
	const [t] = useTranslation()

	return(
		<>
			<Divider height={20}/>
			<RadioGroup field='isActive'>
				<Radio label={t('category_section.strings.all_categories')} />
				<Radio value={true} label={t('category_section.strings.active_category')} />
				<Radio value={false} label={t('category_section.strings.inactive_category')} />
			</RadioGroup>
			<Divider height={20}/>
			<Select
				field='cashRegisterId'
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				isSearchable
				withVirtualBody
				remoteOptions={{ query: listCashRegisters }}
				label={t('common.fields.cash_registers')}
			/>
			<Select
				field='tagId'
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{ query: listTags, variables: { type: 'CategoryTag' } }}
				label={t('category_section.fields.group_tag')}
			/>
		</>
	)
}

export default FilterComponent
